// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuHeaderComponent_wrapper__seDCh","line":"MenuHeaderComponent_line__XzpM7","lineEnd":"MenuHeaderComponent_lineEnd__t5a+Z"};